<template>
    <div class="speedComponent" v-if="prizeList.length">
        <div class="helpBtn" @click="goToHelpListPage">
            助力好友 <span>></span>
        </div>
        <div class="speed">
            <p :style="{width: `${shareAssistanceNum/maxPrizeNumber *100}%`}"></p>
            <ul>
                <li
                    v-for="item in prizeList"
                    :key="item.activityPrizeId"
                    :class="['prize',{lastPrize: item.number === maxPrizeNumber}]"
                    :style="{left: `${item.number / maxPrizeNumber * 100}%`}"
                    @click="goToPrizePage"
                >
                    <div class="status" v-if="prizeList.length > 1">
                        <span v-if="item.isReceive">已领取</span>
                        <span class="active" v-else-if="item.diffNum === 0">去领奖</span>
                        <span v-else>差{{item.diffNum}}人</span>
                    </div>
                    <div
                        :class="['imgBox',{shaking: !item.isReceive && item.diffNum === 0}]"
                        :style="{transform:`scale(${item.sacle})`}"
                    >
                        <img :src="item.isReceive ? item.imgBoBg : item.imgbg" alt="">
                    </div>

                </li>
            </ul>
        </div>
        <div class="tips">
            <span v-if="tipsInfo.receiveOver">奖品已领取，快去参与其他活动吧~</span>
            <span v-else-if="tipsInfo.diffOver">已邀请{{shareAssistanceNum}}人，快快点击宝箱去领奖～</span>
            <span v-else>
                已邀请 <span class="special">{{shareAssistanceNum}}</span>人，还差<span class="special">{{tipsInfo.diffNum}}</span>人即可领{{tipsInfo.prizeName}}
            </span>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex';
import _ from 'lodash';
import wx from 'weixin-js-sdk';

export default {
  props: {
    activityInfo: {
      type: Object,
    },
  },
  computed: {
    ...mapState(['userInfo']),
    tipsInfo() {
      const info = {};
      const noReceive = this.prizeList.filter((item) => !item.isReceive); // 未领取的数据
      const diffData = this.prizeList.filter((item) => item.diffNum > 0); // 未满足领奖条件的数据
      if (noReceive.length === 0) { // 奖品已领完
        info.receiveOver = true;
      } else if (diffData.length === 0) { // 已达到所有领取条件
        info.diffOver = true;
      } else if (this.prizeList.length === 1) { // 奖品只有一个时
        info.diffNum = diffData[0].diffNum;
        info.prizeName = '奖~';
      } else {
        info.diffNum = diffData[0].diffNum;
        info.prizeName = diffData[0].tipsName;
      }
      return info;
    },
  },
  data() {
    return {
      maxPrizeNumber: 0, // 宝箱最大邀请人数
      shareAssistanceNum: 0, // 已邀请人数
      prizeList: [],
      box1: require('@/assets/img/pullNew/box1.png'),
      boxBo1: require('@/assets/img/pullNew/boxBo1.png'),
      box2: require('@/assets/img/pullNew/box2.png'),
      boxBo2: require('@/assets/img/pullNew/boxBo2.png'),
      box3: require('@/assets/img/pullNew/box3.png'),
      boxBo3: require('@/assets/img/pullNew/boxBo3.png'),
      mapping: ['一', '二', '三', '四', '五', '六', '七', '八'],
    };
  },
  methods: {
    detailData() {
      let info = [];
      const { pullNewActivityShareData } = this.activityInfo;
      let { pullNewActivityPrizeDataList } = this.activityInfo;
      pullNewActivityPrizeDataList = pullNewActivityPrizeDataList ?? [];
      this.shareAssistanceNum = pullNewActivityShareData.shareAssistanceNum || 0;
      const allPrizeNum = pullNewActivityPrizeDataList?.length;
      if (allPrizeNum) {
        this.maxPrizeNumber = Math.max(...pullNewActivityPrizeDataList.map((item) => item.number));
      }
      const data = _.cloneDeep(pullNewActivityPrizeDataList).sort((a, b) => a.number - b.number);// 按照从小到大排序 设置宝箱样式
      info = data.map((item, index) => {
        const diffNum = item.number < this.shareAssistanceNum ? 0 : item.number - this.shareAssistanceNum; // 该奖品还需几人才能领取
        Object.assign(
          item, {
            sacle: 1 - ((allPrizeNum - index) / 40), // 宝箱缩放比例
            // eslint-disable-next-line no-nested-ternary
            imgbg: allPrizeNum === index + 1 ? this.box1 : allPrizeNum === index + 2 ? this.box2 : this.box3, // 领取前宝箱背景图
            // eslint-disable-next-line no-nested-ternary
            imgBoBg: allPrizeNum === index + 1 ? this.boxBo1 : allPrizeNum === index + 2 ? this.boxBo2 : this.boxBo2, // 领取后宝箱背景图
            diffNum,
            tipsName: `取奖品${this.mapping[index]}`,
          },
        );
        return item;
      });
      this.prizeList = info;
    },
    goToPrizePage() {
      // 判断是否登录
      if (this.userInfo.id) {
        this.$router.push({
          path: '/pullnew/prize',
          query: {
            activityId: this.activityInfo.activityId,
            pullNewType:this.$root.pullNewType === 2?'yt':''
          },
        });
      } else if (this.$root.$data.isApp) {
        this.$sendToApp('login');
      } else if (this.$root.miniprogram) {
        let url = window.location.href;
        const [domain, searchParams] = url.split('?');
        if (searchParams) {
          const params = searchParams.split('&');
          const paramsMap = new Map();

          params.forEach((item) => {
            const [key, value] = item.split('=');
            console.log('key', key, value);
            if (key) {
              paramsMap.set(key, value);
            }
          });
          const entries = paramsMap.entries();
          let query = '';
          const ExcludequeryArr = ['THIRD_SESSION', 'env'];
          // eslint-disable-next-line no-restricted-syntax
          for (const [key, value] of entries) {
            if (!ExcludequeryArr.includes(key)) query += `${key}=${value}&`;
          }
          url = `${domain}?${query}`;
        } else {
          url = `${domain}`;
        }
        const redirctUrl = encodeURIComponent(`/subPackages/customShareWebview/webView?url=${encodeURIComponent(url)}`);
        const path = `/subPackages/loginPage/loginPage?isHandle=1&isWebview=1&isCancelgoBack=1&redirctUrl=${redirctUrl}`;
        wx.miniProgram.redirectTo({
          url: path,
        });
      } else {
        const { path, query } = this.$route;
        this.$router.push({ path: '/registrationLogin', query: { redirect: path,loginSource:this.$root.pullNewType===2?'yuntulogin':'', ...query } });
      }
    },
    goToHelpListPage() {
      if (this.userInfo.id) {
        this.$router.push({
          path: '/pullnew/helpList',
          query: {
            activityId: this.activityInfo.activityId,
            pullNewType:this.$root.pullNewType === 2?'yt':''
          },
        });
      } else if (this.$root.$data.isApp) {
        this.$sendToApp('login');
      } else if (this.$root.miniprogram) {
        let url = window.location.href;
        const [domain, searchParams] = url.split('?');
        if (searchParams) {
          const params = searchParams.split('&');
          const paramsMap = new Map();

          params.forEach((item) => {
            const [key, value] = item.split('=');
            console.log('key', key, value);
            if (key) {
              paramsMap.set(key, value);
            }
          });
          const entries = paramsMap.entries();
          let query = '';
          const ExcludequeryArr = ['THIRD_SESSION', 'env'];
          // eslint-disable-next-line no-restricted-syntax
          for (const [key, value] of entries) {
            if (!ExcludequeryArr.includes(key)) query += `${key}=${value}&`;
          }
          url = `${domain}?${query}`;
        } else {
          url = `${domain}`;
        }
        const redirctUrl = encodeURIComponent(`/subPackages/customShareWebview/webView?url=${encodeURIComponent(url)}`);
        const path = `/subPackages/loginPage/loginPage?isHandle=1&isWebview=1&isCancelgoBack=1&redirctUrl=${redirctUrl}`;
        wx.miniProgram.redirectTo({
          url: path,
        });
      } else {
        const { path, query } = this.$route;
        this.$router.push({ path: '/registrationLogin', query: { redirect: path,loginSource:this.$root.pullNewType===2?'yuntulogin':'', ...query } });
      }
    },
  },
  mounted() {
    this.detailData();
  },
};
</script>
<style scoped lang="scss">
.speedComponent {
    position: relative;
    width: 686px;
    height: 392px;
    margin: 48px auto;
    padding: 222px 48px 0;
    background: url('../../../assets/img/pullNew/speed.png') no-repeat;
    background-size: 100% auto;
    .helpBtn {
        position: absolute;
        top: 10px;
        right: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 134px;
        height: 44px;
        color: #fff;
        font-size: 24px;
        background: red;
        border: 2px solid #fff;
        border-radius: 28px;
        span {
            margin-left: 4px;
            font-size: 15px;
        }
    }
    .speed {
        position: relative;
        width: 100%;
        height: 16px;
        background: #FCE1DF;
        border-radius: 10px;
        p {
            // width: 20%;
            max-width: 100% !important;
            height: 100%;
            background: #FF712C;
            border-radius: 10px;
        }
        .prize {
            position: absolute;
            bottom: -20px;
            display: flex;
            flex-direction:column;
            align-items: center;
            justify-content: flex-end;
            width: 92px;
            height: 120px;
            transform: translateX(-50%);
            .status {
                span {
                    display: block;
                    width: 92px;
                    height: 46px;
                    font-size: 20px;
                    line-height: 40px;
                    text-align: center;
                    background: url('../../../assets/img/pullNew/status1.png') no-repeat;
                    background-size: 100% auto;
                }
                .active {
                    color: #fff;
                    background: url('../../../assets/img/pullNew/status2.png') no-repeat;
                    background-size: 100% auto;
                }

            }
            .imgBox {
                width:80px;
                height: 80px;
                img {
                    width: 100%;
                    height: 100%;
                }
            }
            .shaking {
                animation: shake 1s infinite;
            }
            @keyframes shake {
                0% { transform: rotate(0deg); }
                80% { transform: rotate(0deg); }
                85% { transform: rotate(10deg); }
                95% { transform: rotate(-10deg); }
                100% { transform: rotate(0deg); }
            }
        }
        .lastPrize {
            left: 97% !important;
        }
    }
    .tips {
        width: 100%;
        margin-top: 50px;
        color: #333;
        font-size: 28px;
        text-align: center;
        .special {
            margin: 0 5px;
            color: #FF3938;
            font-weight: bold;
            font-size: 36px;
        }
    }
}
</style>
